import CMSLink from '@components/CMSLink';
import Button from '@components/ui/button';
import Container from '@components/ui/container';
import React, { ReactElement } from 'react';
import Grid from '../components/grid';
import Text from '../components/ui/text';

export default function StandaloneHeaderCluster(block: any): ReactElement {
  const { title, subTitle, options, containerClassName } = block;

  return (
    <Container className={containerClassName}>
      <Grid className="gap-0 place-content-center lg:gap-x-8">
        <div
          id={options?.elementId}
          className="flex flex-col col-span-full md:col-span-4 lg:col-span-6 xl:col-span-7"
        >
          <h5 className="mb-1 lg:mb-2 text-opacity-50">{subTitle}</h5>
          <Text variant="subHeading">{title}</Text>
        </div>
        {options?.hasButtons && (
          <div className="col-span-full flex flex-col md:col-span-4 lg:flex-row md:justify-between items-center lg:col-span-6 xl:col-span-5 lg:justify-end mt-4">
            {options?.buttons &&
              options.buttons.map((btn: any, i: number, arr: any) => {
                const { link, options } = btn;
                const { variant = 'flat' } = options;

                const isLast = arr.length - 1 === i ? true : false;

                const isMany = arr.length > 1 ? true : false;

                return (
                  <CMSLink
                    {...link}
                    className={`sm:mb-8 ${isMany && 'w-full'} lg:mb-0 ${
                      !isLast && ' lg:mr-8'
                    }`}
                  >
                    <Button variant={variant} className="w-full">
                      {link.label}
                    </Button>
                  </CMSLink>
                );
              })}
          </div>
        )}
        <div
          className={`h-[1px] bg-black col-span-full md:col-span-8 lg:col-span-full xl:col-span-full my-4 md:my-6 lg:my-8 xl:my-10`}
        />
      </Grid>
    </Container>
  );
}
